export const Actions = {
    Create: 'CREATE', // An entity was created
    Update: 'UPDATE', // An entity was updated
    Delete: 'DELETE', // An entity was deleted
    ChangePassword: 'CHANGE_PASSWORD', // A user's password was changed
    UnitCommand: 'UNIT_COMMAND', // A command was sent to a unit
    UnitConfig: 'UNIT_CONFIG', // A configuration was sent to a unit
    UserNotFound: 'USER_NOT_FOUND', // User tried to login but their email address was not found
    PasswordNotSet: 'PASSWORD_NOT_SET', // User tried to login but they didn't have a password set
    BadPassword: 'BAD_PASSWORD', // User tried to login, but gave a bad password
    LoginSuccess: 'LOGIN_SUCCESS', // User logged in successfully
    CampaignNotifiedUserAdd: 'CAMPAIGN_NOTIFIED_USER_ADD', // Notified User was added to a campaign
    CampaignNotifiedUserDel: 'CAMPAIGN_NOTIFIED_USER_DEL', // Notified User was removed from a campaign
    CampaignUserAdd: 'CAMPAIGN_USER_ADD', // User was added to a campaign
    CampaignUserDel: 'CAMPAIGN_USER_DEL', // User was removed from a campaign
    CampaignClone: 'CAMPAIGN_CLONE', // Campaign was cloned
    NotificationAck: 'NOTIFICATION_ACK', // Notification was acknowledged
    NotificationAllAck: 'NOTIFICATION_ALL_ACK', // All notifications for a campaign were acknowledged
    CampaignViewerUserAdd: 'CAMPAIGN_VIEWER_USER_ADD', // Viewer User was added to a campaign
    CampaignViewerUserDel: 'CAMPAIGN_VIEWER_USER_DEL', // Viewer User was removed from a campaign
};
